import { createContext, useContext } from "react";
import type { PrescriptionDetail } from "@interfaces";

interface DocumentFlowRoutes {
  searchBackRoute: string;
  treatmentRoute: string;
  treatmentBackRoute: string;
  afterSubmitRoute: string;
}

interface DocumentFlowLabels {
  treatmentTitle: string;
  submitButtonText?: string;
  searchTitle: string;
  mobileSearchTitle: string;
}

export interface DocumentFlowConfig {
  routes: DocumentFlowRoutes;
  labels: DocumentFlowLabels;
  submitDetail: (detail: PrescriptionDetail) => Promise<void>;
  enableInteractions: boolean;
  showTemplatesSection: boolean;
}

const DocumentFlowContext = createContext<DocumentFlowConfig | null>(null);

export function useDocumentFlow(): DocumentFlowConfig {
  const ctx = useContext(DocumentFlowContext);

  if (!ctx) {
    throw new Error(
      "useDocumentFlow must be used within a DocumentFlowProvider (PrescriptionFlowProvider or TemplateFlowProvider)",
    );
  }

  return ctx;
}

export { DocumentFlowContext };
